import ProductApi from "../../../../services/api/productApi.js";
import FavoritesApi from "../../../../services/api/favoritesApi.js";

import ProductDescriptionHeader from "../productDescriptionHeader/productDescriptionHeader.vue";
import { mapGetters } from "vuex";
import algoliasearch from "algoliasearch/lite";
import { cartHelper } from "@/components/mixin/cartHelper";
import { productDetailsHelper } from "@/components/mixin/product/productDetailsHelper";
import InlineSvg from "vue-inline-svg";

const ProductApiService = new ProductApi(),
  FavoritesApiService = new FavoritesApi();

export default {
  mixins: [cartHelper, productDetailsHelper],
  components: {
    ProductDescriptionHeader,
    InlineSvg,
  },
  data() {
    return {
      numberOfOptions: null,
      selectedOption: {},
      selectedVariant: null,
      show: false,
      product: null,
      totalPrice: 0,
      quantity: null,
      fulfilledQuantity: null,
      shippedQuantity: null,
      faveData: null,
      config: {},
    };
  },

  computed: {
    suborderStatus,
    suborderStatusMessage,
    canChooseFulfilledQuantity,
    canChooseShippedQuantity,
    ...mapGetters({
      user: "userState",
    }),
  },

  methods: {
    optionDropdownCallback,
    selectVariant,
    onQuantityChange,
    onFulfilledQuantityChange,
    onShippedQuantityChange,
    close,
    showQuickShopModalCallback,
    showQuickShopModalByIdCallback,
    updateProductWithMovData,
    updateTotalPrice,
    handleAddToCart,
  },

  mounted() {
    this.$eventBus.$on("show-quick-shop-modal", this.showQuickShopModalCallback);
    this.$eventBus.$on("show-quick-shop-modal-by-id", this.showQuickShopModalByIdCallback);
    this.$eventBus.$on("close-quick-shop-modal", this.close);
  },

  beforeDestroy() {
    this.$eventBus.$off("show-quick-shop-modal", this.showQuickShopModalCallback);
    this.$eventBus.$off("show-quick-shop-modal-by-id", this.showQuickShopModalByIdCallback);
    this.$eventBus.$on("close-quick-shop-modal", this.close);
  },
};

function optionDropdownCallback(optionValue, optionName) {
  this.selectedOption[optionName] = optionValue;

  if (Object.keys(this.selectedOption).length === this.numberOfOptions) {
    this.selectVariant(this.$utils.findVariantByOptions(this.product.variants, this.selectedOption));
  }
}

function selectVariant(val) {
  if (val) {
    this.selectedVariant = val;
    this.totalPrice = this.quantity * this.selectedVariant.price;
  } else {
    this.$swal(
      "Attention",
      "Sorry, this variant is not available at the moment. Please select another combination of options"
    );
  }
}

function showQuickShopModalByIdCallback(id) {
  const objectArray = [];
  objectArray.push(id);
  algoliasearch(this.$env.algolia().appId, this.$env.algolia().token, {
    timeouts: {
      connect: this.$utils.constants.ALGOLIA_CONNECT_TIMEOUT,
      read: this.$utils.constants.ALGOLIA_READ_TIMEOUT,
    },
  })
    .initIndex(this.$env.getOrigin() + "_products")
    .getObjects(objectArray)
    .then((data) => this.showQuickShopModalCallback(data.results[0]));
}
function showQuickShopModalCallback(product, config) {
  const _self = this;
  _self.config = config || {};

  ProductApiService.getProduct(product.id)
    // eslint-disable-next-line complexity
    .then(async (response) => {
      // save product option number
      _self.numberOfOptions = response.data.characteristics.length;
      _self.product = product;
      _self.product.description = response.data.description;
      _self.product.brand_values = response.data.brand_values;
      _self.product.brand.vanity_url_name = response.data.brand_vanity_url_name;
      _self.product.characteristics = response.data.characteristics;

      _self.product.variants = this.mapVariants(response.data?.variants);
      _self.hasInStockVariant = _self.product.variants?.filter((variant) => variant.in_stock).length;
      _self.quantity = _self.product.wholesale_minimum;
      _self.product.brand.minimum_order_value = response.data.brand_minimum_order_value;

      if (_self.product.variants.length === 1) {
        _self.selectVariant(_self.product.variants[0]);
      }

      _self.show = true;
      _self.$ma.trackEvent({
        action: "View PDP",
        properties: {
          "Pdp Type": "quickshop",
          "Entry Point": window.location.href,
          "Product Name": _self.product.name,
          Brand: _self.product.brand.company_name,
          "Product Id": _self.product.id,
        },
      });

      if (_self.user && _self.user.role === "RETAILER") {
        const orderCount = (await _self.$utils.getOrderCount(_self.product.brand.id)).data.order_count;

        if (orderCount > 0) {
          _self.product.brand.minimum_order_value = response.data.brand_minimum_reorder_value;
        }
      }

      _self.updateProductWithMovData(_self.product);

      if (_self.user && _self.user.role === "RETAILER") {
        FavoritesApiService.getFavoriteProducts()
          .then((response) => {
            let ids = response.data.product_ids;
            if (ids === undefined) {
              ids = [];
            }
            _self.faveData = {
              is_fav: ids.includes(_self.product.id),
              id: _self.product.id,
            };
          })
          .catch((error) => {
            if (error.response) {
              _self.$swal("Attention", error.response.data.error_message);
            } else {
              _self.$bugsnagClient.notify(new Error(error));
            }
          });
      }
    })
    .catch((error) => {
      if (error.response) {
        _self.$swal("Attention", error.response.data.error_message);
      } else {
        _self.$bugsnagClient.notify(new Error(error));
      }
    });
}

function getBrandMinimumData(productID) {
  const cartData = JSON.parse(localStorage.getItem("CHECKOUT_BULLETIN"));
  if (cartData) {
    const brandData = cartData.brands
      .filter((brand) => brand.info.id === productID)
      .map((brand) => {
        return {
          subtotal: brand.subtotal,
          balance: brand.info.minimum_order_value - brand.subtotal,
        };
      });
    return brandData.length === 0 ? false : brandData[0];
  }
  return false;
}

function updateProductWithMovData(product) {
  const data = getBrandMinimumData(product.brand.id);
  if (data) {
    product.showMinimum = false;
    product.showMinReached = data.balance <= 0;
    product.amountToGo = data.balance.toFixed(this.$utils.constants.PRICE_FORMAT_DECIMAL_PLACES);
  } else {
    product.showMinimum = true;
  }
}

function onQuantityChange(val) {
  this.quantity = val;
  if (this.selectedVariant) {
    this.updateTotalPrice(this.quantity, this.selectedVariant.price);
  }
}

function onFulfilledQuantityChange(val) {
  this.fulfilledQuantity = val;
}

function onShippedQuantityChange(val) {
  this.shippedQuantity = val;
}

function updateTotalPrice(quantity, price) {
  this.totalPrice = quantity * price;
}

function close() {
  this.totalPrice = 0;
  this.selectedVariant = null;
  this.selectedOption = {};
  this.show = false;
  this.product = null;
}

function suborderStatus() {
  return this.config.suborder ? this.config.suborder.status : null;
}

function canChooseFulfilledQuantity() {
  return (
    this.suborderStatus === "APPROVED" ||
    this.suborderStatus === "FULFILLMENT_IN_PROGRESS" ||
    this.suborderStatus === "SHIPPED"
  );
}

function canChooseShippedQuantity() {
  return this.suborderStatus === "FULFILLMENT_IN_PROGRESS" || this.suborderStatus === "SHIPPED";
}

function suborderStatusMessage() {
  return `The status of this suborder is '${this.config.suborder.status}'.`;
}

function handleAddToCart() {
  if (this.config.isOrderAdjustmentModal) {
    this.$eventBus.$emit("order-adjustment-product-added", this.selectedVariants);
  } else {
    this.addToCart();
  }
}
